<template>
  <v-container>
    <!-- <v-layout justify-space-between>
      <h1>New Fixed Cost Trip</h1>
    </v-layout>-->
    <v-layout justify-center py-3 row wrap>
      <v-flex xs12 md10 xl8>
        <SimpleCard>
          <v-btn @click="update">Update</v-btn>
          <v-flex pl-5 pb-3>
            <v-layout justify-start align-content-start row wrap>
              <v-flex xs12>
                <h4>Dispatch Frame</h4>
              </v-flex>
              <v-flex xs12>
                <v-row align-center>
                  <v-flex xs12 v-for="(tbl, index) in tbls" shrink pr-2>
                    <h4>{{ dates[index] + " " + algorithms[index] }}</h4>
                    <table>
                      <tr v-for="item in tbl" >
                        <th v-for="field in item" v-html="field">
                        </th>
                      </tr>
                    </table>
                  </v-flex>
                </v-row>
              </v-flex>
            </v-layout>
          </v-flex>
        </SimpleCard>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Overview from "@/components/settings/Overview.vue";

import SimpleCard from "@/components/widget/SimpleCard.vue";

import axios from "axios";
axios.defaults.withCredentials = true;

import SimpleCurrencyInput from "@/components/widget/input/SimpleCurrencyInput.vue";

import qs from "qs";

export default {
  name: "fixed_pricing",
  components: {
    Overview,
    SimpleCard,
    SimpleCurrencyInput,
  },
  data: function () {
    return {
      currency_config: {
        decimal: ".",
        prefix: "£",
        precision: 2,
        masked: false,
        allowBlank: true,
      },
      loading: false,
      chargeCancellationFee: false,
      cancellationFee: 0,
      chargeExtrasInCancellationFee: false,
      asapLatenessFeeWaiveMinutes: 0,
      prebookedLatenessFeeWaiveMinutes: 0,
      tbls: [],
      dates: [],
      algorithms: []
    };
  },
  mounted: async function () {
    this.getBookingSettings();

    console.log("HELLO")
  },
  methods: {
    update: function (p) {
      console.log("Form Submitted");

      this.loading = true;

      var url = `${
        this.$store.state.apiUrl
      }/overwatch/autoDispatchFrames`;

      var completed = this.success;

      console.log(url);

      var vm = this;

      axios({
        url: url,
        method: "GET",
        data: {},
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(function (res) {

          console.log(res.data);

          var iTbls = [];
          var frames = res.data;
          var dates = [];
          var algorithms = [];

          console.log(frames.length)

          for (var j = 0; j < frames.length; j++) {

        
            var frame = frames[j];

            dates.push(frame.timestamp);
            algorithms.push(frame.algorithm);

            console.log(frame.id);

            var rows = frame.frame.split("\n");
            
            var rowsSplit = [];

            for (var i = 0; i < rows.length; i++) {
              var column = rows[i].split("\t");

              rowsSplit.push(column);
            }

            iTbls.push(rowsSplit);
            
          }
          
          vm.tbls = iTbls;
          vm.dates = dates;
          vm.algorithms = algorithms;

          console.log(vm.tbls)
        })
        .catch(function (err) {
          alert("Internal Server Error");
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
table, th, td, tr {
  border: 1px solid black !important;
  font-size: 10px;
  font-weight: 500;
} 
</style>
